import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlService {
  static get host(): string {
    return environment.api;
  }
  protected get uploadFile() {
    return UrlService.host + 'uploads';
  }
  protected get getimportantUpdate(): string {
    return UrlService.host + 'small/sections/';
  }
  protected get importantUpdate(): string {
    return UrlService.host + 'small/section/';
  }
  protected get getevent(): string {
    return UrlService.host + 'upcomming/sections/';
  }
  protected get event(): string {
    return UrlService.host + 'upcomming/section/';
  }
  protected get getlatestNews(): string {
    return UrlService.host + 'latest/news/sections/';
  }
  protected get latestNews(): string {
    return UrlService.host + 'latest/news/section/';
  }
  protected get getheroSection(): string {
    return UrlService.host + 'main/sections/';
  }
  protected get herosection(): string {
    return UrlService.host + 'main/section/';
  }
  protected get heromobsection(): string {
    return UrlService.host + 'main/mobile/section/';
  }

  protected get getexternallink(): string {
    return UrlService.host + 'external/link/sections/';
  }
  protected get externallink(): string {
    return UrlService.host + 'external/link/section/';
  }
  protected get getcircular(): string {
    return UrlService.host + 'circulars/sections/';
  }
  protected get circularlink(): string {
    return UrlService.host + 'circulars/section/';
  }
  protected get getgallerysection(): string {
    return UrlService.host + 'gallery/sections/';
  }
  protected get gallerysection(): string {
    return UrlService.host + 'gallery/section/';
  }
  protected get getwhoisWho(): string {
    return UrlService.host + 'whos/who/sections/';
  }
  protected get whoisWho(): string {
    return UrlService.host + 'whos/who/section/';
  }
  protected get updatedDate(): string {
    return UrlService.host + '/latest/updated/at';
  }
  protected get vistorCount(): string {
    return UrlService.host + '/iplogs';
  }
  protected get ContactForm(): string {
    return UrlService.host + 'contact/form/submission';
  }
  protected get EnquiryForm(): string {
    return UrlService.host + 'enquiry/form/submission';
  }
  protected get getContactForm(): string {
    return UrlService.host + 'contact/form/details';
  }
  protected get getEnquiryForm(): string {
    return UrlService.host + 'enquiry/form/details';
  }
  protected get getSupportForm(): string {
    return UrlService.host + 'support/form/details';
  }
  protected get statusContactURL(): string {
    return UrlService.host + 'contact/form/status';
  }
  protected get statusEnquiryURL(): string {
    return UrlService.host + 'enquiry/form/status';
  }
  protected get statusSupportURL(): string {
    return UrlService.host + 'support/form/status';
  }
  protected get verifyOtpURL(): string {
    return UrlService.host + 'public-appointment/verify-otp';
  }
  protected get sendOtpURL(): string {
    return UrlService.host + 'public-appointment/send-otp';
  }
  protected get appointmentURL(): string {
    return UrlService.host + 'appointment/form/submission';
  }
}
